import {
  GET_USER_TERMS,
  GET_USER_TERMS_SUCCESS,
  GET_USER_TERMS_FAILURE,
} from "@utils/actionTypes";

const INIT_STATE = {
  loadingUserTerms: false,
};

const usersReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_TERMS:
      return { ...state, loadingUserTerms: true };
    case GET_USER_TERMS_SUCCESS:
      return { ...state, loadingUserTerms: false };
    case GET_USER_TERMS_FAILURE:
      return { ...state, loadingUserTerms: false };

    default:
      return state;
  }
};
export default usersReducer;
